export const CopyToClipboard = (textToCopy: string, callback: () => void) =>
  navigator.clipboard.writeText(textToCopy).then(callback);
